import { module } from "../app";
import * as commonConstants from '../constants/constantStrings';

module.directive('followUpPatientDetails', [ 
  'modalService', 'Patient', '$ionicLoading', 'signalrService', 'ageHelper',
  function (modalService, Patient, $ionicLoading, signalrService, ageHelper) {
    return {
      restrict: "E",
      templateUrl: "views/templates/followUpPatientDetails.html",
      scope: {
        patientAccessToken: "=",
        clip: "="
      },
      link: async function (scope, element, ngModel) {

        scope.getPatientFullName = () => {          
          const fullName = `${scope.patientDetails.LastName}, ${scope.patientDetails.FirstName}`;
          return fullName;
        }

        scope.formatDateString = (dateString) => {
          const date = new Date(dateString);
          const formattedDate = `${date.getMonth()+1}/${date.getDate()}/${date.getFullYear()}`;
          return formattedDate;
        }

        scope.getPatientAgeAndDobString = () => {
          const formattedDob = scope.formatDateString(scope.patientDetails.DOB);
          const age = scope.getPatientsAge();
          const ageAndDobString = `Age: ${age}, ${formattedDob}`;

          return ageAndDobString;
        }

        scope.getPatientsAge = () => {
          let patientsAge = '';

          if (scope.patientDetails && scope.patientDetails.DOB) {
            let dateOfBirth = new Date(scope.patientDetails.DOB);
            patientsAge = ageHelper.getAgeFromBirthDate(dateOfBirth);
          }

          return patientsAge;
        }

        scope.loadPatientData = async () => {
          if (!signalrService.isConnected) {
            await modalService.showAlertAsync(commonConstants.OFFLINE_ERROR_MESSAGE);
            return;
          }

          try {
            const resp = await Patient.getByAccessToken(scope.patientAccessToken); 
            scope.patientDetails = resp.data;
          } catch (errorResponse) {
            $ionicLoading.hide();
            modalService.showErrorMessage(errorResponse || commonConstants.DEFAULT_LOAD_PATIENT_DATA_ERROR_MESSAGE);
          }          
        };

        scope.initialize = async () => {
          await scope.loadPatientData();
          
          scope.patientFullName = scope.getPatientFullName();
          scope.patientAgeAndDobString = scope.getPatientAgeAndDobString();          
        }

        scope.showPatClipPopup = async () => {
          const clipData = (scope.clip || {}).Flag;
          await modalService.showAlertAsync(clipData);
        };

        await scope.initialize();
      }
    };
  }]);


// WEBPACK FOOTER //
// ./src/scripts/directives/follow-up-patient-details.js